import { Navigate, useParams } from 'react-router-dom'

import { ContentLoading, ContinueBootScreen } from 'src/components'
import { useFeatureFlagsServerSettled } from 'src/feature-flags'
import { WorkspaceHomePage } from 'src/features/workspaces'
import { useFeatureHomeAi } from 'src/flags'

import { paths } from './paths'

/**
 * Gates the workspace Home (the Core AI assistant chat) behind the home-ai
 * flag. When OFF the chat is unreachable — even via a deep link — and the
 * workspace lands on Overview instead. This mirrors WorkspaceFeatureRoute,
 * which the other workspace features use, but falls back to Overview rather
 * than Home: Home is itself the fallback target for those routes, so it can't
 * redirect to itself.
 *
 * The decision waits on `useFeatureFlagsServerSettled` (NOT the weaker
 * `useFeatureFlagsReady`): the client reports "ready" from the OFF bootstrap
 * before it has fetched, so redirecting on that would bounce a refreshed /
 * deep-linked session off a Home that is actually enabled for its environment.
 */
export const WorkspaceHomeRoute = () => {
  const settled = useFeatureFlagsServerSettled()
  const enabled = useFeatureHomeAi()
  const { id } = useParams<{ id: string }>()

  if (!settled) {
    return <ContentLoading />
  }

  if (!enabled) {
    return (
      <>
        <ContinueBootScreen />
        <Navigate
          to={id ? paths.workspaces.overview(id) : paths.workspaces.root}
          replace
        />
      </>
    )
  }

  return <WorkspaceHomePage />
}
